import { LANGUAGE_OPTIONS } from '@myap/metadata';
import { SelectField } from '../../forms/FormikFields';
import { FIELD_LANG, REQUIRED_STUDENT_VALUES } from '../constants';
function SelectPreferredLanguage(_ref) {
  var isCurrentYear = _ref.isCurrentYear,
    setFieldValue = _ref.setFieldValue,
    disabled = _ref.disabled;
  if (isCurrentYear) {
    return /*#__PURE__*/React.createElement(SelectField, {
      id: FIELD_LANG,
      label: "Which Language Do You Know Best?",
      name: FIELD_LANG,
      options: LANGUAGE_OPTIONS,
      required: REQUIRED_STUDENT_VALUES[FIELD_LANG],
      onChange: function onChange(val) {
        return setFieldValue(FIELD_LANG, !Number.isNaN(parseInt(val, 10)) ? parseInt(val, 10) : val);
      },
      disabled: disabled
    });
  }
  return null;
}
export default SelectPreferredLanguage;